import PlaylistsTable from '../../../components/PlaylistsTable'
import { useAppSelector } from '../../../utils/redux/store'

export default function AllPlaylists() {
  const { playlists, total } = useAppSelector((state) => state.playlists)
  return <PlaylistsTable playlists={Object.values(playlists)} total={total}/>
}
